export const toggleFullscreen = (
  callback?: (isFullscreen: boolean) => void,
) => {
  if (document.fullscreenElement) {
    return document.exitFullscreen().then(() => callback?.(false));
  }
  return document.documentElement
    .requestFullscreen()
    .then(() => callback?.(true));
};
